import React from 'react';
import { BarChart3, CreditCard, FileEdit, Globe, Palette, StickyNote, Target } from 'lucide-react';
import type { ActivityType } from 'shared/src/api/activity-feed-api-types';

export type ActivityTypeMeta = {
  label: string;
  colorClass: string;
  stripeClass: string;
  Icon: React.ComponentType<{ className?: string }>;
};

export function getActivityTypeMeta(activityType: ActivityType): ActivityTypeMeta {
  switch (activityType) {
    case 'campaign_change':
      return {
        label: 'Campaign',
        colorClass: 'bg-blue-100 text-blue-700',
        stripeClass: 'border-l-blue-500',
        Icon: BarChart3
      };
    case 'strategy_change':
      return {
        label: 'Strategy',
        colorClass: 'bg-purple-100 text-purple-700',
        stripeClass: 'border-l-purple-500',
        Icon: Target
      };
    case 'line_item_change':
      return {
        label: 'Line Item',
        colorClass: 'bg-green-100 text-green-700',
        stripeClass: 'border-l-green-500',
        Icon: FileEdit
      };
    case 'platform_entity_change':
      return {
        label: 'Platform',
        colorClass: 'bg-orange-100 text-orange-700',
        stripeClass: 'border-l-orange-500',
        Icon: Globe
      };
    case 'rate_card_change':
      return {
        label: 'Rate Card',
        colorClass: 'bg-yellow-100 text-yellow-700',
        stripeClass: 'border-l-yellow-500',
        Icon: CreditCard
      };
    case 'zoho_note':
      return {
        label: 'Zoho Note',
        colorClass: 'bg-pink-100 text-pink-700',
        stripeClass: 'border-l-pink-500',
        Icon: StickyNote
      };
    case 'creative_request':
      return {
        label: 'Creative',
        colorClass: 'bg-indigo-100 text-indigo-700',
        stripeClass: 'border-l-indigo-500',
        Icon: Palette
      };
    default: {
      const _exhaustive: never = activityType;
      return {
        label: String(_exhaustive),
        colorClass: 'bg-gray-100 text-gray-700',
        stripeClass: 'border-l-gray-400',
        Icon: FileEdit
      };
    }
  }
}

export function isCampaignCentricActivityType(activityType: ActivityType): boolean {
  return activityType === 'campaign_change' || activityType === 'strategy_change';
}
